import { render, staticRenderFns } from "./DuplicateDetailsModal.vue?vue&type=template&id=0c0f1004&scoped=true"
import script from "./DuplicateDetailsModal.vue?vue&type=script&lang=js"
export * from "./DuplicateDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateDetailsModal.vue?vue&type=style&index=0&id=0c0f1004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f1004",
  null
  
)

export default component.exports